import { ActivityCalendar, iDateCell } from './ActivityCalendar'
import { iData, iKpis } from '../Utils/Types'
import { GumRoad } from '../Layout/cta'

import React from 'react'


const parseDate = (date: Date) => `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}-${date.getUTCDate()}`
const parseDates = ({data, counter}: {data: iData, counter(data: iKpis):number}) => {
    const dates: iDateCell[] = data.kpis.map(k => {
        const date = new Date(k.date)
        return { date: parseDate(date), count: counter(k.kpis) }
    })

    const maxValue = Math.max(...dates.map(({ count }) => count))/4
    const normalizedDates: iDateCell[] = dates.map(v => ({ ...v, style: Math.ceil(v.count/maxValue) }))
    return normalizedDates
    // TODO: Find Bug here.
}

const tweetsCounter = (k: iKpis) => k.Tweets
const totalsCounter = (k: iKpis) => k.Tweets + k.Comments
const impressionsCounter = (k: iKpis) => k.Impressions
const engagementCounter = (k: iKpis) => k.Likes + k.Replies + k.Retweets + k.Visits

export const HeatMap = ({data}: {data: iData}) => data.paying 
    ?
        <>
            <div className="columns">
                <div className="column" style={{textAlign: 'center', marginTop: 64}} >
                    <ActivityCalendar 
                        dates = { parseDates({ data, counter:tweetsCounter }) } 
                        title = { 'Tweets' } 
                        color = { 'tweets' }
                    />
                </div>

                <div className="column" style={{textAlign: 'center', marginTop: 64}} >
                    <ActivityCalendar 
                        dates={ parseDates({ data, counter:impressionsCounter }) } 
                        title={ 'Impressions' } 
                        color={ 'impressions' } 
                    />
                </div>
            </div>

            <div className="columns">
                <div className="column" style={{textAlign: 'center', marginTop: 64}} >
                    <ActivityCalendar 
                        dates={ parseDates({ data, counter:totalsCounter }) } 
                        title={'Tweets & Replies'} 
                        color={'likes'}
                    />
                </div>

                <div className="column" style={{textAlign: 'center', marginTop: 64}} >
                    <ActivityCalendar 
                        dates={ parseDates({ data, counter:engagementCounter }) } 
                        title={'Engagements'} 
                        color={'engagements'}
                    />
                </div>
            </div>
        </>
    :   
        <div className="columns"> 
            <div className="column" style={{textAlign: 'center', marginTop: 64}} >
                <p className="subtitle is-4" style={{color: 'white', marginBottom: 36}}> 
                    Heatmaps are a <span style={{color:'goldenrod'}}>premium feature.</span> <br/><br/>

                    Please consider making a purchase <br/> 
                    to support the project:
                </p>
                <GumRoad />
            </div>
        </div>
